/**
 * Repository entry point (CONTRACTS.md §3). Feature code consumes ONLY
 * `repositories` from here; implementations live in ./supabase/.
 *
 * When Supabase is not configured every method throws the typed
 * SUPABASE_NOT_CONFIGURED AppError from requireSupabase() — there is no
 * silent local-only fallback and no fake cloud success.
 */
import type { Repositories } from './interfaces'
import { breathingRepository } from './supabase/breathingRepository'
import { caregiverRepository } from './supabase/caregiverRepository'
import { healthRepository } from './supabase/healthRepository'
import { journalRepository } from './supabase/journalRepository'
import { medicationRepository } from './supabase/medicationRepository'
import { notesRepository } from './supabase/notesRepository'
import { notificationRepository } from './supabase/notificationRepository'
import { placesRepository } from './supabase/placesRepository'
import { plannerRepository } from './supabase/plannerRepository'
import { profileRepository } from './supabase/profileRepository'

export const repositories: Repositories = {
  profile: profileRepository,
  planner: plannerRepository,
  notes: notesRepository,
  journal: journalRepository,
  health: healthRepository,
  places: placesRepository,
  breathing: breathingRepository,
  medication: medicationRepository,
  caregiver: caregiverRepository,
  notifications: notificationRepository,
}

export { subscribeMedicationRealtime } from './supabase/realtime'
export type { MedicationRealtimeEvent, SubscribeMedicationRealtimeOptions } from './supabase/realtime'
export { UNDO_WINDOW_MS } from './supabase/medicationRepository'
